export default __webpack_public_path__ + "static/media/Jag Nagendra.bb97b9c4.jpg";